module.exports = __webpack_public_path__ + "static/media/image6.f92eba15.JPG";